import { Box, Button, FileButton, Grid, Group, Menu, NumberInput, ScrollArea, Table, TextInput } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconDownload, IconFileUpload, IconWindow } from "@tabler/icons-react";
import cx from "clsx";
import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import classes from "../../../../../Styles/TableScrollArea.module.css";
import { repositoryDelivery } from "../../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../../_base/extension/NotificationExtension";
import { sky_blue } from "../../../../../const/variables";
import { MessageResponse } from "../../../../../model/MessageResponse";
import { tblPromotionItemGiftCommand } from "../../../../../model/TblPromotion";

interface ModelItemEquivalentGiftProps {
    dataEdit: tblPromotionItemGiftCommand;
    currentSiblings?: tblPromotionItemGiftCommand[];
    editItemDiscount: (dataParent: tblPromotionItemGiftCommand, dataSiblings: tblPromotionItemGiftCommand[]) => void;
}

const ModelItemEquivalentGift = ({ dataEdit, currentSiblings, editItemDiscount }: ModelItemEquivalentGiftProps) => {
    const resetRef = useRef<() => void>(null);
    const [scrolled, setScrolled] = useState(false);
    const [scrolledView, setScrolledView] = useState(false);

    const [searchGift, setSearchGift] = useDebouncedState<string>("", 300);
    const [dataGift, setDataGift] = useState<any[]>([]);
    const [dataViewGift, setDataViewGift] = useState<tblPromotionItemGiftCommand[]>([]);
    const handleFileUpload = (file: File) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryData = event.target?.result;
            const workbook = XLSX.read(binaryData, { type: "binary" });

            // Lấy sheet đầu tiên
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json<any>(sheet);
            const mappedData: any[] = jsonData.map((row: any, index: number) => ({
                itemPrimaryCode: row["Mã sản phẩm"] || null,
                itemPrimaryName: row["Tên sản phẩm"] || null,
                itemGiftCode: row["Mã sản phẩm"] || null,
                itemGiftName: row["Tên sản phẩm"] || null,
            }));
            const dataOld = dataViewGift
                .filter((item) => item.isNotDelete)
                .map((item) => item.itemPrimaryCode);
            const dataSet = mappedData.filter(
                (item) => !dataOld.includes(item.itemPrimaryCode)
            );
            setDataViewGift((x) => filterDuplicateItems([...dataSet, ...x]));
        };

        reader.readAsBinaryString(file);
    };

    const filterDuplicateItems = (dataArray: any) => {
        const seen = new Set();

        return dataArray.filter((item: any) => {
            if (seen.has(item.itemPrimaryCode)) {
                return false;
            }

            seen.add(item.itemPrimaryCode);
            return true;
        });
    };
    const getProductGift = async () => {
        let url = `/api/v1/TblDmItemCategoryCombination/get-list?Skip=0&Take=100`;

        if (searchGift.length > 0) {
            url += `&ItemCodes=${searchGift}`;
        }

        const res = await repositoryDelivery.get<MessageResponse<any>>(url);

        if (res && res.success) {
            const result = res.data;
            setDataGift(result);
        }
    };

    useEffect(() => {
        getProductGift();
    }, [searchGift]);

    useEffect(() => {
        if (dataViewGift.length > 100) {
            NotificationExtension.Fails(
                "Quà tặng tương đương không được quá 100 sản phẩm !"
            );
        }
    }, [dataViewGift]);



    const getProductGiftEdit = async () => {
        if (currentSiblings && currentSiblings.length > 0) {
            // const listCheckItemCodeOld =
            //     currentSiblings && currentSiblings.length > 0
            //         ? currentSiblings?.map((i: tblPromotionItemGiftCommand) => i.itemPrimaryCode)
            //         : [];

            const dataSet = currentSiblings.map((i: tblPromotionItemGiftCommand) => ({
                ...i,
                // isNotDelete: listCheckItemCodeOld.includes(i.itemPrimaryCode),
            }));

            setDataViewGift(dataSet);
        } else {
            setDataViewGift([]);
        }
    };


    useEffect(() => {
        if (currentSiblings && currentSiblings.length > 0) {
            getProductGiftEdit();
        }
    }, [currentSiblings, dataEdit]);

    const handleQuantityChange = (itemCode: string, field: string, value: number | string | null) => {
        setDataViewGift((prev) =>
            prev.map((item) =>
                (item.itemPrimaryCode || "") === itemCode ? { ...item, [field]: value } : item
            )
        );
    };

    return (
        <Box style={{
            width: "100%",
            height: "100%",
            minWidth: "1000px",
            maxWidth: "1000px",
        }}>
            <Grid>
                <Grid.Col span={{ base: 12, md: 12 }}>
                    <Menu trigger="hover">
                        <Menu.Target>
                            <TextInput
                                label="Quà tặng tương đương"
                                placeholder="Nhập sản phẩm tương đương"
                                defaultValue={searchGift}
                                onChange={(e) => setSearchGift(e.currentTarget.value)}
                            />
                        </Menu.Target>
                        <Menu.Dropdown>
                            <ScrollArea
                                h={400}
                                onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                            >
                                <Table striped highlightOnHover mt={10}>
                                    <Table.Thead
                                        className={cx(classes.header, {
                                            [classes.scrolled]: scrolled,
                                        })}
                                    >
                                        <Table.Tr>
                                            <Table.Th>Mã sản phẩm</Table.Th>
                                            <Table.Th>Tên sản phẩm</Table.Th>
                                            <Table.Th>Thao tác</Table.Th>
                                        </Table.Tr>
                                    </Table.Thead>
                                    <Table.Tbody>
                                        {dataGift && dataGift.length > 0 ? (
                                            dataGift.map((item, index) => (
                                                <Table.Tr key={index}>
                                                    <Table.Td w={100}>{item.itemCode}</Table.Td>
                                                    <Table.Td w={475}>{item.itemName}</Table.Td>
                                                    <Table.Td w={85}>
                                                        <Button
                                                            variant="outline"
                                                            onClick={() =>
                                                                setDataViewGift((prev) => {
                                                                    const newItem: tblPromotionItemGiftCommand = {
                                                                        ...item,
                                                                        idItemGift: item.itemId,
                                                                        itemGiftCode: item.itemCode,
                                                                        itemGiftName: item.itemName,
                                                                        itemPrimaryCode: item.itemCode,
                                                                        itemPrimaryName: item.itemName,
                                                                        idItemPrimary: item.itemId,
                                                                        attribute2: dataEdit.itemPrimaryCode, // Gán cha
                                                                        quantityMin: null,
                                                                        quantityMax: null,
                                                                        quantityApply: null,
                                                                    };
                                                                    return [...prev, newItem];
                                                                })
                                                            }
                                                            disabled={
                                                                dataViewGift.filter(
                                                                    (i) => i.itemPrimaryCode === item.itemCode
                                                                ).length > 0
                                                            }
                                                        >
                                                            {dataViewGift.filter(
                                                                (i) => i.itemPrimaryCode === item.itemCode
                                                            ).length > 0
                                                                ? "Đã chọn"
                                                                : "Chọn"}
                                                        </Button>
                                                    </Table.Td>
                                                </Table.Tr>
                                            ))
                                        ) : (
                                            <Table.Tr>
                                                <Table.Td rowSpan={3} ta={"center"}>
                                                    {searchGift.length === 0
                                                        ? "Nhập ít nhất 3 kí tự để tìm kiếm !"
                                                        : "Không tìm thấy sản phẩm !"}
                                                </Table.Td>
                                            </Table.Tr>
                                        )}
                                    </Table.Tbody>
                                </Table>
                            </ScrollArea>
                        </Menu.Dropdown>
                    </Menu>
                </Grid.Col>
                {/* <Grid.Col span={{ base: 6, md: 2 }}>
                    <Button
                        leftSection={<IconDownload size={16} />}
                        mt={22.5}
                        variant="outline"
                        component="a"
                        href="/template/TemplateUploadGiftSimilar.xlsx"
                        download
                    >
                        Tải file mẫu
                    </Button>
                </Grid.Col>
                <Grid.Col span={{ base: 6, md: 2 }}>
                    <FileButton
                        resetRef={resetRef}
                        onChange={(file) => {
                            if (
                                file &&
                                (file.type ===
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                                    file.type === "application/vnd.ms-excel")
                            ) {
                                handleFileUpload(file);
                            } else
                                NotificationExtension.Fails(
                                    "File không đúng định đạng Excel !"
                                );
                            resetRef.current?.();
                        }}
                    >
                        {(props) => (
                            <Button
                                leftSection={<IconFileUpload size={16} />}
                                mt={22.5}
                                {...props}
                            >
                                Import Excel
                            </Button>
                        )}
                    </FileButton>
                </Grid.Col> */}
                <Grid.Col span={12}>
                    <ScrollArea
                        h={400}
                        onScrollPositionChange={({ y }) => setScrolledView(y !== 0)}
                    >
                        <Table striped highlightOnHover>
                            <Table.Thead
                                className={cx(classes.header, {
                                    [classes.scrolled]: scrolledView,
                                })}
                            >
                                <Table.Tr>
                                    <Table.Th>Mã sản phẩm</Table.Th>
                                    <Table.Th>Tên sản phẩm</Table.Th>
                                    <Table.Th style={{ textAlign: "center" }}>SL tối thiểu</Table.Th>
                                    <Table.Th style={{ textAlign: "center" }}>SL tối đa</Table.Th>
                                    <Table.Th style={{ textAlign: "center" }}>SL áp dụng</Table.Th>
                                    <Table.Th>Thao tác</Table.Th>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                {dataViewGift && dataViewGift.length > 0 ? (
                                    dataViewGift.map((item, index) => (
                                        <Table.Tr key={index}>
                                            <Table.Td w={100}>{item.itemPrimaryCode}</Table.Td>
                                            <Table.Td w={200}>{item.itemPrimaryName}</Table.Td>
                                            <Table.Td w={100}>
                                                <NumberInput
                                                    placeholder="SL tối thiểu"
                                                    value={item.quantityMin ?? undefined}
                                                    onChange={(value) => handleQuantityChange(item.itemPrimaryCode || "", "quantityMin", value ? value : null)}
                                                    min={0}
                                                />
                                            </Table.Td>
                                            <Table.Td w={100}>
                                                <NumberInput
                                                    placeholder="SL tối đa"
                                                    value={item.quantityMax ?? undefined}
                                                    onChange={(value) => handleQuantityChange(item.itemPrimaryCode || "", "quantityMax", value ? value : null)}
                                                    min={0}
                                                />
                                            </Table.Td>
                                            <Table.Td w={100}>
                                                <NumberInput
                                                    placeholder="SL áp dụng"
                                                    value={item.quantityApply ?? undefined}
                                                    onChange={(value) => handleQuantityChange(item.itemPrimaryCode || "", "quantityApply", value ? value : null)}
                                                    min={0}
                                                />
                                            </Table.Td>
                                            <Table.Td w={55}>
                                                <Button
                                                    variant="outline"
                                                    color="red"
                                                    onClick={() => {
                                                        const dataDelete = dataViewGift.filter(
                                                            (i) => i.itemPrimaryCode !== item.itemPrimaryCode
                                                        );

                                                        setDataViewGift(dataDelete);
                                                    }}
                                                >
                                                    Xóa
                                                </Button>
                                            </Table.Td>
                                        </Table.Tr>
                                    ))
                                ) : (
                                    <Table.Tr>
                                        <Table.Td colSpan={3} ta={"center"} fw={500} h={350}>
                                            Bạn chưa chọn quà tặng tương đương nào !
                                        </Table.Td>
                                    </Table.Tr>
                                )}
                            </Table.Tbody>
                        </Table>
                    </ScrollArea>
                </Grid.Col>
            </Grid>
            <Group justify="end" mt="md">
                <Button
                    type="button"
                    color="gray"
                    onClick={() => {
                        modals.closeAll();
                    }}
                    leftSection={<IconWindow size={18} />}
                >
                    Đóng
                </Button>
                <Button
                    type="submit"
                    color={sky_blue.base}
                    leftSection={<IconCheck size={18} />}
                    disabled={dataViewGift.length > 100}
                    onClick={() => {
                        // Cập nhật tất cả hàng con để trỏ về hàng cha
                        const updatedSiblings = dataViewGift.map((item: tblPromotionItemGiftCommand) => ({
                            attribute2: dataEdit.itemPrimaryCode,//mã của thằng cha
                            isChild: true,
                            discountAmount: item.discountAmount,
                            discountPercent: item.discountPercent,
                            id: 0,
                            idItemGift: item.idItemGift,
                            idItemPrimary: null,
                            itemGiftCode: item.itemPrimaryCode,
                            itemGiftName: item.itemPrimaryName,
                            itemPrimaryCode: item.itemPrimaryCode,
                            itemPrimaryName: item.itemPrimaryName,
                            price: item.price,
                            priceMax: item.priceMax,
                            priceMin: item.priceMin,
                            promoteDetailId: item.promoteDetailId,
                            promoteId: item.promoteId,
                            quantityApply: item.quantityApply,
                            quantityMax: item.quantityMax,
                            quantityMin: item.quantityMin
                        }));

                        editItemDiscount(
                            { ...dataEdit, attribute2: null }, // Cha luôn để attribute2 = null
                            updatedSiblings
                        );
                    }}
                >
                    Lưu
                </Button>
                <></>
            </Group >
        </Box>
    )
}

export default ModelItemEquivalentGift
